export const API_KEY = 'AIzaSyBFU8Xutwnzsh-FKpKuVlsREXNDn0e1jLY'
// AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg - api key for local development
// AIzaSyBFU8Xutwnzsh-FKpKuVlsREXNDn0e1jLY  - api key for dev/prod environment
const CALLBACK = 'gmapsCallback'

// @ts-ignore
let initialized = !!window.google
let resolveInitPromise: any
let rejectInitPromise: any

const initPromise = new Promise((resolve, reject) => {
  resolveInitPromise = resolve
  rejectInitPromise = reject
})

export default () => {
  if (initialized) { return initPromise }

  initialized = true
  // @ts-ignore
  window[CALLBACK] = () => resolveInitPromise(window.google)

  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=${CALLBACK}`
  // @ts-ignore
  script.onerror = rejectInitPromise
  document.querySelector('head').appendChild(script)

  return initPromise
}
